export const restrictedTimingKeys: string[] = ['ssr'];

export const clsWaitTimeMs: number = 7500;
